import { memo, useCallback } from 'react';
import { SYSTEM_DATE_FORMAT } from '../../constants';
import { dateFormat } from '../../utils';
import DateInput from '../DateInput';

export const GuestBirthdayField = memo(function GuestBirthdayField({
    fieldName,
    roomIndex,
    guestIndex,
    guestBirthday,
    onGuestUpdate,
}) {
    const displayValue = guestBirthday ? dateFormat(guestBirthday) : '';

    const handleDateChange = useCallback((event) => {
        const newValue = event.date ? moment(event.date).format(SYSTEM_DATE_FORMAT) : '';
        onGuestUpdate(roomIndex, guestIndex, 'birthday', newValue);
    }, [onGuestUpdate, roomIndex, guestIndex]);

    return (
        <DateInput
            className="form-control input-sm"
            name={fieldName}
            value={displayValue}
            removeButton={true}
            onChange={handleDateChange} />
    );
});
